import "./authentication.module";

const context = require.context(
  "./",
  true,
  /^(?!.*\.module\.js$)^(?!.*\.spec\.js$).*\.js$/
);

context.keys().forEach(context);

export default angular.module("mso.authentication");
